<template>
	<div v-if="!hide" class="landing-lottie-animation" ref="animationContainer" :style="customStyles" />
</template>

<script>
import { lottieLoadAnimation } from '@/helpers/lottie'

export default {
	name: 'LandingLottieAnimation',

	props: {
		hide: {
			type: Boolean,
			default: false,
		},

		loop: {
			type: Boolean,
			default: false,
		},

		animationData: {
			type: [Object, String],
			default: null,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},

	async mounted() {
		let animationDataToUse = null

		if (typeof this.animationData === 'string') {
			animationDataToUse = await this.fetchAnimationData(this.animationData)
		} else if (typeof this.animationData === 'object') {
			animationDataToUse = this.animationData
		}

		if (!animationDataToUse) {
			animationDataToUse = require('@/data/lottie-animations/genderSelectionLoader.json')
		}

		lottieLoadAnimation({
			container: this.$refs.animationContainer,
			renderer: 'svg',
			loop: this.loop,
			autoplay: true,
			animationData: JSON.parse(JSON.stringify(animationDataToUse)),
		})
	},

	methods: {
		async fetchAnimationData(url) {
			try {
				const response = await fetch(url)

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`)
				}

				const data = await response.json()
				return data
			} catch (error) {
				console.error('[LandingLottieAnimation] Failed to fetch animation from URL:', url, error)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-lottie-animation {
	& :deep(svg) {
		display: block;
		margin: 0 auto;
	}
}
</style>
